
import { v4 as uuid } from 'uuid';
import { F01_ExportData } from '../pages/FrmCommonExport/F01_ExportManager';
import dayjs from 'dayjs';

export class F01Cache {

  static END_POINT = "f01_cache";

  serno = 0;
  guid;//= uuid();

  /** 紀錄時間 */
  rec_dt = "2999-01-01 00:00:00";
  
  /** 注意! 這裡是Web的 MemberGuid 與 後台的GUID不同，要改用 MemberCode 比對 */
  member_guid = "";

  json = "";

  constructor()
  {
    this.guid = uuid();
  }

  static new_F01Cache(member_guid: string, f01_data: F01_ExportData): F01Cache {
    const re = new F01Cache();

    re.guid = uuid();
    re.rec_dt = dayjs().format("YYYY-MM-DD HH:mm:ss");

    re.member_guid = member_guid;
    
    const data = new F01_Cache_Json(f01_data);// 轉換為欄位名稱較短的格式

    re.json = JSON.stringify(data);

    return re;
  }

}


/**
 * 匯出時，由 F01_ExportData 轉換為此格式，快取備用
 * 保存到 f01_cache 讓後台存取
 */
class F01_Cache_Json {

  constructor(f01_data: F01_ExportData) {
    
    this.填寫日期 = f01_data.填寫日期;

    this.項次 = f01_data.項次;

    this.廠區 = f01_data.廠區;
    this.部門代號 = f01_data.部門代號;
    this.部門名稱 = f01_data.部門名稱;

    this.工號 = f01_data.工號;
    this.姓名 = f01_data.姓名;
    this.健檢日期 = f01_data.健檢日期;

    this.性別 = f01_data.性別;

    /* (一)個人	*/
    this.Q1_1 = f01_data.Q1_1_你常覺得疲勞嗎;// 1.1
    this.Q1_2 = f01_data.Q1_2_你常覺得身體上體力透支嗎;// 1.2
    this.Q1_3 = f01_data.Q1_3_你常覺得情緒上心力交瘁嗎;// 1.3
    this.Q1_4 = f01_data.Q1_4_你常會覺得我快要撐不下去了嗎;// 1.4
    this.Q1_5 = f01_data.Q1_5_你常覺得精疲力竭嗎;// 1.5
    this.Q1_6 = f01_data.Q1_6_你常常覺得虛弱好像快要生病了嗎;// 1.6

    /* (二)工作 */
    this.Q2_1 = f01_data.Q2_1_你的工作會令人情緒上心力交瘁嗎;// 2.1
    this.Q2_2 = f01_data.Q2_2_你的工作會讓你覺得快要累垮了嗎;// 2.2
    this.Q2_3 = f01_data.Q2_3_你的工作會讓你覺得挫折嗎;// 2.3
    this.Q2_4 = f01_data.Q2_4_工作一整天之後你覺得精疲力竭嗎;// 2.4
    this.Q2_5 = f01_data.Q2_5_上班之前只要想到又要工作一整天你就覺得沒力嗎;// 2.5
    this.Q2_6 = f01_data.Q2_6_上班時你會覺得每一刻都很難熬嗎;// 2.6
    this.Q2_7 = f01_data.Q2_7_不工作的時候你有足夠的精力陪朋友或家人嗎;// 2.7

    this.Q1_Score = f01_data.Q1_總分_個人疲勞;
    this.Q1_Risk = f01_data.Q1_個人疲勞分級;

    this.Q2_Score = f01_data.Q2_總分_工作疲勞;
    this.Q2_Risk = f01_data.Q2_工作疲勞分級;
  }

  // PROJECT_GUID = "";

  // MEMBER_GUID = "";
  // MemberCode = "";

  //--------------------------------
  填寫日期 = "";

  項次 = "";

  廠區 = "";
  部門代號 = "";
  部門名稱 = "";

  工號 = "";
  姓名 = "";
  健檢日期 = "";

  性別 = "";
  //---------------------------------

  /* (一)個人	*/
  Q1_1 = "";// 1.1 _你常覺得疲勞嗎
  Q1_2 = "";// 1.2 _你常覺得身體上體力透支嗎
  Q1_3 = "";// 1.3 _你常覺得情緒上心力交瘁嗎
  Q1_4 = "";// 1.4 _你常會覺得我快要撐不下去了嗎
  Q1_5 = "";// 1.5 _你常覺得精疲力竭嗎
  Q1_6 = "";// 1.6 _你常常覺得虛弱好像快要生病了嗎

  /* (二)工作 */
  Q2_1 = "";// 2.1 _你的工作會令人情緒上心力交瘁嗎
  Q2_2 = "";// 2.2 _你的工作會讓你覺得快要累垮了嗎
  Q2_3 = "";// 2.3 _你的工作會讓你覺得挫折嗎
  Q2_4 = "";// 2.4 _工作一整天之後你覺得精疲力竭嗎
  Q2_5 = "";// 2.5 _上班之前只要想到又要工作一整天你就覺得沒力嗎
  Q2_6 = "";// 2.6 _上班時你會覺得每一刻都很難熬嗎
  Q2_7 = "";// 2.7 _不工作的時候你有足夠的精力陪朋友或家人嗎

  Q1_Score = "";// 總分_個人疲勞
  Q1_Risk = "";// _個人疲勞分級

  Q2_Score = "";// _總分_工作疲勞
  Q2_Risk = ""; // _工作疲勞分級

}
